import React from 'react'
import Footer from '../footer/Footer'
import HomeNavbar from '../navbar/Navbar'
import './style.scss'

const Wrapper = (props) => {

    return (
        <div id="langDirection">
            <HomeNavbar />
            <div className="main_wrapper">
                {props.children}
            </div>
            <Footer />
        </div>
    )
}

export default Wrapper
